// @subframe/sync-disable

"use client";
/*
 * Documentation:
 * Button — https://app.subframe.com/4f62853ee923/library?component=Button_3b777358-b86b-40af-9327-891efc6826fe
 * DC_Card_Hash — https://app.subframe.com/4f62853ee923/library?component=DC_Card_Hash_e9b19441-52e1-4d0a-ae52-460245adcdf3
 */

import React from "react";
import * as SubframeCore from "@subframe/core";
import * as SubframeUtils from "../utils";
import { Button } from "./Button";
import { Tooltip } from "./Tooltip";

interface JumpLinkProps extends React.ComponentProps<typeof Button> {
  children?: React.ReactNode;
  className?: string;
}

const JumpLink = React.forwardRef<
  React.ElementRef<typeof Button>,
  JumpLinkProps
>(function JumpLink(
  { children, className, ...otherProps }: JumpLinkProps,
  ref
) {
  return (
    <Button
      className={className}
      variant="brand-secondary"
      ref={ref}
      {...otherProps}
    >
      {children}
    </Button>
  );
});

interface Dc_Card_HashRootProps extends React.HTMLAttributes<HTMLDivElement> {
  imageSlot?: React.ReactNode;
  headline?: React.ReactNode;
  text?: React.ReactNode;
  imageCredits?: React.ReactNode;
  buttonSlot?: React.ReactNode;
  buttonText?: React.ReactNode;
  className?: string;
}

const Dc_Card_HashRoot = React.forwardRef<
  HTMLDivElement,
  Dc_Card_HashRootProps
>(function Dc_Card_HashRoot(
  {
    imageSlot,
    headline,
    text,
    imageCredits,
    buttonSlot,
    buttonText,
    className,
    ...otherProps
  }: Dc_Card_HashRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex flex-col items-start gap-2",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      <div className="flex items-center rounded-md bg-neutral-50 px-4 py-4 comp-card-hash-wrapper">
        <div className="flex flex-col items-center gap-6">
          {imageSlot ? (
            <SubframeCore.Tooltip.Provider>
              <SubframeCore.Tooltip.Root>
                <SubframeCore.Tooltip.Trigger asChild={true}>
                  <div className="flex h-80 w-full flex-none items-center gap-2 overflow-hidden rounded-md">
                    {imageSlot}
                  </div>
                </SubframeCore.Tooltip.Trigger>
                <SubframeCore.Tooltip.Portal>
                  <SubframeCore.Tooltip.Content
                    side="bottom"
                    align="center"
                    sideOffset={8}
                    asChild={true}
                  >
                    <Tooltip>{imageCredits}</Tooltip>
                  </SubframeCore.Tooltip.Content>
                </SubframeCore.Tooltip.Portal>
              </SubframeCore.Tooltip.Root>
            </SubframeCore.Tooltip.Provider>
          ) : null}
          <div className="flex w-full flex-col items-start gap-4">
            {headline ? (
              <span className="w-full text-heading-3 font-heading-3 text-default-font comp-card-hash-headline">
                {headline}
              </span>
            ) : null}
            {text ? (
              <span className="w-full text-body font-body text-default-font">
                {text}
              </span>
            ) : null}
            {buttonSlot ? (
              <div className="flex flex-col items-start gap-6">
                {buttonSlot}
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
});

export const Dc_Card_Hash = Object.assign(Dc_Card_HashRoot, {
  JumpLink,
});
